// extracted by mini-css-extract-plugin
module.exports = {"accordionToggle":"RetailerWidgetSettings_accordionToggle__A_HCy"};